var config = require('./config');
// import request from 'superagent';

const useLocalStorage = true;
const LOCAL_STORAGE_KEY = 'reldesk-token';

class APIClient {
	auth = null;

	constructor() {
		// this.removeToken();
		this.useLocalStorage = (typeof localStorage !== 'undefined');
		this.subscribers = [];

		if (this.useLocalStorage) {
			this.auth = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));

			if (this.auth) {
				this.isTokenValid().then((bool) => {
					// console.log('is token valid (' + this.auth.token + ') : ' + bool);
					if (!bool) this.auth = null;
				});
			}
		}
	}

	login(email, password) {
		var data = {
			email: email,
			password: password,
		}

		return fetch(config.api.server + '/api/auth/login', {
			method: 'post',
			body: JSON.stringify(data),
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			},
		}).then(this.checkStatus)
			.then(this.parseJSON)
			.then((json) => {
				// console.log("JSON", json);
				this.setAuthResponse(json);
				return json;
			})
			.catch((err) => {
				const error = new Error(`General Network Error`);
				error.status = "0"
				error.response = err
		        window.Raven.captureException(error, {  });
				throw error;
			});
			// .then((json) => this.setAuthResponse(json));
	}


	register(data, cb) {
		return fetch(config.api.server + '/api/auth/register', {
			method: 'post',
			body: JSON.stringify(data),
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			},
		}).then(this.checkStatus)
			.then(this.parseJSON)
			.then((json) => {
				if (json.token)	this.setAuthResponse(json);
				// console.log("JSON", json);
				return json;
			})
			.catch((err) => ({err}));
	}



	logout() {
		this.removeToken();
	}


	// Generic 'get' request for simple calls
	get(endpoint, success) {
		return fetch(config.api.server + endpoint, {
			headers: {
				Accept: 'application/json',
				'Authorization': 'Bearer ' + this.getToken(),
			},
		}).then(this.checkStatus)
			.then(this.parseJSON)
			.then(success);
	}

	// Generic 'post' request for simple calls
	post(endpoint, data, cb) {
		return fetch(config.api.server + endpoint, {
			method: 'post',
			body: JSON.stringify(data),
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + this.getToken(),
			},
		}).then(this.checkStatus)
			.then(this.parseJSON)
			.then(cb);
	}


	// Generic 'put' request for simple calls
	put(endpoint, data, cb) {
		return fetch(config.api.server + endpoint, {
			method: 'put',
			body: JSON.stringify(data),
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + this.getToken(),
			},
		}).then(this.checkStatus)
			.then(this.parseJSON)
			.then(cb);
	}

	// Generic 'delete' request for simple calls
	delete(endpoint, data) {
		return fetch(config.api.server + endpoint, {
			method: 'delete',
			body: JSON.stringify(data),
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + this.getToken(),
			},
		}).then(this.checkStatus);
	}


	//----


	getProfile(cb) {
		return fetch(config.api.server + '/api/user/profile', {
			method: 'get',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + this.getToken(),
			},
		}).then(this.checkStatus)
			.then(this.parseJSON)
			.then(cb);
	}


	updateProfile(data, cb) {
		return fetch(config.api.server + '/api/user/profile', {
			method: 'put',
			body: JSON.stringify(data),
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + this.getToken(),
			},
		}).then(this.checkStatus)
			.then(this.parseJSON)
			.then(cb);
	}




	// ------

	createAppointment(data, success) {
		return fetch(config.api.server + '/api/crm/appointments/create', {
			method: 'post',
			body: JSON.stringify(data),
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + this.getToken(),
			},
		}).then(this.checkStatus)
			.then(this.parseJSON)
			.then(success);
	}


	getAppointments(success) {
		// console.log('getting apts')
		return fetch(config.api.server + '/api/crm/appointments', {
			headers: {
				'Accept': 'application/json',
				'Authorization': 'Bearer ' + this.getToken(),
			},
		}).then(this.checkStatus)
			.then(this.parseJSON)
			.then(success);
	}


	// ------
	setAuthResponse(data) {
		// console.log("Saving User", data);
		this.auth = data;
		if (useLocalStorage) localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(data));
	}


	removeToken() {
		if (this.auth) this.auth.token = null;
		if (useLocalStorage) localStorage.removeItem(LOCAL_STORAGE_KEY);
		// console.log("Token now ", this.auth.token);
	}

	getToken() {
		if (this.auth) return this.auth.token;
		else return null;
		// return this.auth.token;
	}


	isTokenValid() {
		// console.log("Checking token is valid " + this.auth.token);
		return fetch(config.api.server + '/api/auth/token/' + this.auth.token, {
			method: 'get',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			},
		}).then(this.checkStatus)
			.then(this.parseJSON)
			.then((json) => json.valid === true);
	}


	checkStatus = (response) => {
		if (response.status >= 200 && response.status < 300) {
			return response;
		} else {
			// If we receive an unauthorised response, logout the user
			// (this should be changed in future when separate products are added which may result in unauthorised response but should
			// still remain logged in.
			// console.log(response.status);
			if (response.status === 401) {
				// console.log("Removing token");
				this.logout();
				return response;
				// throw new UnauthorisedException("You are not authenticated");
			}
			else if (response.status === 400) {
				return response;
			}
			else if (response.status === 409) {
				// response.json().then(function(data) {
				// 	//console.log(data.code);
				// 	//console.log(data.message);
				// 	const error = new Error(`HTTP Error ${response.statusText}`);
				// 	error.status = response.statusText;
				// 	error.response = response;
				// 	error.data = data;
				// 	throw error;
				// });
				return response;
			}
			else {
			// response.json().then(function(data) {  
				// console.log("DATA", data); 
				// console.log(response);
				// console.log(response.json());
				const error = new Error(`HTTP Error ${response.statusText}`);
				// const error = new Error(`HTTP Error`);
				error.status = response.statusText;
				error.response = response;
				// error.data = data;
				// error.data = data;
				// // console.log("Error ", error);
				throw error;
			// });
			}

		}
	}

	parseJSON(response) {
		return response.json();
	}


	isLoggedIn() {
		if (!this.auth) return false;
		
		return !!this.auth.token;
		// if (this.auth) return !!this.auth.token;
		// else return false;
	}

	getFirstname() {
		if (this.auth) return this.auth.firstname;
	}

	getLastname() {
		if (this.auth) return this.auth.lastname;
	}

}

export const Client = new APIClient();


// function UnauthorisedException(message) {
// 	this.message = message;
// 	this.name = 'UnauthorisedException';
// }












// WEBPACK FOOTER //
// ./src/js/Client.js